"use client";

import { Children, type FC, Fragment, type ReactNode } from "react";
import { separate, type Separated } from "@huub-web/utils";

import { Ruler } from "../Ruler/Ruler";

export interface SeparateProps {
  separator?: Separated<ReactNode>;
  children?: ReactNode;
}

/**
 * A component that separates its children with a separator.
 */
export const Separate: FC<SeparateProps> = ({
  separator = <Ruler />,
  children,
}) => {
  const separated = (() => {
    const array: (ReturnType<typeof Children.toArray>[number] | null)[] =
      Children.toArray(children);

    const separated = separate(array, (index) => (
      <Fragment key={index}>
        {separator instanceof Function ? separator(index) : separator}
      </Fragment>
    ));

    return separated;
  })();

  return <>{separated}</>;
};
